export type MapDriver = { id: number; name: string; lat: number; lng: number; stale: boolean };
export type MapPoint = { lat: number; lng: number };

/**
 * Tap-to-pick page (customer location on a new order). Sends {type:"pick", lat, lng} to the app:
 * ReactNativeWebView.postMessage on phones, parent.postMessage on the web app.
 */
export function pickHtml(point: MapPoint | null): string {
  const data = JSON.stringify(point);
  return `<!doctype html><html><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
<link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css">
<style>html,body,#m{margin:0;height:100%;}</style></head>
<body><div id="m"></div>
<script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
<script>
var p=${data};
var map=L.map('m').setView(p?[p.lat,p.lng]:[33.3152,44.3661],p?16:11);
L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'© OpenStreetMap'}).addTo(map);
var pin=null;
function send(ll){var m=JSON.stringify({type:'pick',lat:ll.lat,lng:ll.lng});
  if(window.ReactNativeWebView)window.ReactNativeWebView.postMessage(m);else parent.postMessage(m,'*');}
function place(ll){if(pin)pin.setLatLng(ll);else{pin=L.marker(ll,{draggable:true}).addTo(map);pin.on('dragend',function(){send(pin.getLatLng())});}}
if(p)place([p.lat,p.lng]);
map.on('click',function(e){place(e.latlng);send(e.latlng);});
</script></body></html>`;
}

/**
 * A self-contained Leaflet page (OpenStreetMap tiles). The same HTML runs in a WebView on
 * phones and in an iframe on the web app, so the map looks identical everywhere.
 */
export function mapHtml(drivers: MapDriver[], path: MapPoint[]): string {
  const data = JSON.stringify({ drivers, path });
  return `<!doctype html><html><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
<link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css">
<link href="https://fonts.googleapis.com/css2?family=Cairo:wght@700&display=swap" rel="stylesheet">
<style>html,body,#m{margin:0;height:100%;}
.lbl{background:#fff;border:2px solid #5A1F82;border-radius:12px;padding:1px 8px;font:700 12px Cairo,sans-serif;color:#4A1872;white-space:nowrap;}
.lbl.stale{border-color:#9A93A8;color:#6F6880}</style></head>
<body><div id="m"></div>
<script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
<script>
var d=${data};
var map=L.map('m',{zoomControl:true}).setView([33.3152,44.3661],11);
L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'© OpenStreetMap'}).addTo(map);
var b=[];
if(d.path.length>1){
  // Raw GPS points first (faint), then snap them to the streets with OSRM's map matching.
  var raw=L.polyline(d.path.map(function(p){return[p.lat,p.lng]}),{color:'#0AABC9',weight:4,opacity:.45,dashArray:'6 8'}).addTo(map);
  var pts=d.path;if(pts.length>100){var step=(pts.length-1)/99,s=[];for(var i=0;i<100;i++)s.push(pts[Math.round(i*step)]);pts=s;}
  var coords=pts.map(function(p){return p.lng.toFixed(6)+','+p.lat.toFixed(6)}).join(';');
  var rad=pts.map(function(){return 30}).join(';');
  fetch('https://router.project-osrm.org/match/v1/driving/'+coords+'?geometries=geojson&overview=full&gaps=ignore&tidy=true&radiuses='+rad)
    .then(function(r){return r.json()})
    .then(function(j){
      if(!j.matchings||!j.matchings.length)return;
      j.matchings.forEach(function(m){L.polyline(m.geometry.coordinates.map(function(c){return[c[1],c[0]]}),{color:'#0AABC9',weight:6,opacity:.95}).addTo(map);});
      map.removeLayer(raw);
    }).catch(function(){raw.setStyle({opacity:.85,dashArray:null});});
}
d.drivers.forEach(function(x){
  var c=L.circleMarker([x.lat,x.lng],{radius:9,color:'#fff',weight:3,fillColor:x.stale?'#9A93A8':'#5A1F82',fillOpacity:1}).addTo(map);
  c.bindTooltip('<div class="lbl'+(x.stale?' stale':'')+'">'+x.name.replace(/</g,'&lt;')+'</div>',{permanent:true,direction:'top',offset:[0,-10],className:'',opacity:1});
  b.push([x.lat,x.lng]);
});
d.path.forEach(function(p){b.push([p.lat,p.lng])});
if(b.length===1)map.setView(b[0],15);else if(b.length>1)map.fitBounds(b,{padding:[40,40],maxZoom:16});
</script></body></html>`;
}
